<template>
	<v-container fluid >
		<Title :title="'Page not found'" />
		<v-row
			align="center"
			justify="center"
		>
			<v-col
				cols="11"
			>
				<v-card>
					<v-subheader>You can try following links</v-subheader>
					<v-list dense>
						<v-list-item link to="/">
							<v-list-item-action>
								<v-icon>{{ 'home' }}</v-icon>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title align="start">Main</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<v-list-item link to="/video">
							<v-list-item-action>
								<v-icon>{{ 'video_library' }}</v-icon>
							</v-list-item-action>
							<v-list-item-content>
								<v-list-item-title align="start">Video Library</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>

	import Title from '../components/Title.vue'

	export default {
		name: 'NotFound',
		components: {
			Title
		}
	}
</script>